export default __webpack_public_path__ + "5dbaa1f2b32e61a034f256e1a9c578b8.svg";